import { render, staticRenderFns } from "./ReportSettingsContainer.vue?vue&type=template&id=59ba0a40&scoped=true"
import script from "./ReportSettingsContainer.vue?vue&type=script&lang=js"
export * from "./ReportSettingsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ba0a40",
  null
  
)

export default component.exports